/* Shopnest theme – vanilla JS, no dependencies */
(function () {
  'use strict';
  var T = window.theme || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Drawers ---------- */
  function openDrawer(id) {
    var d = document.getElementById(id); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var f = d.querySelector('.drawer__head button'); if (f) f.focus();
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.body.classList.remove('no-scroll');
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawers(); closeSearch(); closeFilters(); } });

  /* ---------- Search + filter helpers ---------- */
  function closeSearch() {
    var bar = $('#search-bar'); if (!bar || bar.hidden) return;
    bar.hidden = true; document.body.classList.remove('search-open');
  }
  function closeFilters() {
    var w = $('#filters-wrap'); if (w) w.classList.remove('is-open');
    document.body.classList.remove('filters-open', 'no-scroll');
  }

  /* ---------- Cart helpers ---------- */
  function refreshCart() {
    return fetch(T.routes.root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var doc = new DOMParser().parseFromString(j['cart-drawer'], 'text/html');
        var np = doc.querySelector('.drawer__panel'), op = $('#cart-drawer .drawer__panel');
        if (np && op) op.innerHTML = np.innerHTML;
        return fetch(T.routes.cart + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count > 0 ? cart.item_count : ''; });
      });
  }
  function changeLine(line, qty) {
    return fetch(T.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(refreshCart);
  }

  /* ---------- Click delegation ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var o = t.closest('[data-open]');
    if (o) {
      var id = o.getAttribute('data-open');
      if (id === 'cart-drawer' && T.cartType !== 'drawer') return;
      e.preventDefault(); openDrawer(id); return;
    }
    if (t.closest('[data-close]')) { e.preventDefault(); closeDrawers(); return; }

    var st = t.closest('[data-toggle-search]');
    if (st) {
      var bar = $('#search-bar'); if (!bar) return;
      e.preventDefault(); bar.hidden = !bar.hidden;
      document.body.classList.toggle('search-open', !bar.hidden);
      if (!bar.hidden) { var i = bar.querySelector('input'); if (i) i.focus(); }
      return;
    }
    var ft = t.closest('[data-toggle-filters]');
    if (ft) {
      var wrap = $('#filters-wrap'); if (!wrap) return;
      var openNow = wrap.classList.toggle('is-open');
      document.body.classList.toggle('filters-open', openNow);
      document.body.classList.toggle('no-scroll', openNow);
      return;
    }
    /* tap outside the search overlay closes it (mobile) */
    if (document.body.classList.contains('search-open') && !t.closest('#search-bar') && !t.closest('[data-toggle-search]')) closeSearch();
    /* footer accordion (mobile) */
    var fh = t.closest('.footer__grid > div.is-acc > h4');
    if (fh && isMobile()) { toggleFooterCol(fh); return; }
    /* "Load more" on collection pages */
    var lm = t.closest('[data-load-more]');
    if (lm) { e.preventDefault(); loadMore(lm); return; }

    var step = t.closest('[data-step]');
    if (step) {
      var input = step.parentNode.querySelector('input');
      var v = Math.max(parseInt(input.getAttribute('min') || '0', 10), (parseInt(input.value, 10) || 0) + parseInt(step.getAttribute('data-step'), 10));
      if (String(input.value) !== String(v)) { input.value = v; input.dispatchEvent(new Event('change', { bubbles: true })); }
      return;
    }
    var rm = t.closest('[data-remove-line]');
    if (rm) { e.preventDefault(); changeLine(parseInt(rm.getAttribute('data-remove-line'), 10), 0); }

    var th = t.closest('.gallery__thumb');
    if (th) showMedia(th.getAttribute('data-media-id'));
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('.qty input[data-line]')) { changeLine(parseInt(t.getAttribute('data-line'), 10), parseInt(t.value, 10) || 0); return; }
    if (t.closest('#cart-form') && t.matches('.qty input')) { $('#cart-form').submit(); return; }
    if (t.closest('#filters') || t.getAttribute('form') === 'filters') { $('#filters').submit(); }
  });

  /* ---------- Ajax add to cart (drawer mode) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[data-ajax-cart]') || T.cartType !== 'drawer') return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]'), err = form.querySelector('[data-form-error]');
    if (err) err.textContent = '';
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    fetch(T.routes.cartAdd + '.js', {
      method: 'POST', body: new FormData(form),
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { if (err) err.textContent = res.j.description || res.j.message || 'Could not add to cart.'; return; }
        return refreshCart().then(function () { openDrawer('cart-drawer'); });
      })
      .catch(function () { form.submit(); })
      .then(function () { if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); } });
  });

  /* ---------- Product page ---------- */
  function showMedia(id, fromScroll) {
    $$('.gallery__slide').forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') == id); });
    $$('.gallery__thumb').forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') == id); });
    $$('.gallery__dots span').forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-media-id') == id); });
    if (fromScroll) return;
    var main = $('.gallery__main');
    var slide = main && main.querySelector('.gallery__slide[data-media-id="' + id + '"]');
    if (slide && main.scrollWidth > main.clientWidth + 4) main.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
  }

  function initProduct(root) {
    var jsonEl = $('[data-variants]', root); if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);
    var form = $('form[data-product-form]', root); if (!form) return;
    var idInput = $('[name=id]', form);
    var sid = root.getAttribute('data-section-id'), base = root.getAttribute('data-url');
    root.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option]')) return;
      var sel = $$('[data-option]:checked', root).map(function (i) { return i.value; });
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
      var add = $('[data-add]', root);
      if (!v) { if (add) { add.disabled = true; add.textContent = add.getAttribute('data-unavailable') || 'Unavailable'; } return; }
      idInput.value = v.id;
      history.replaceState(null, '', base + '?variant=' + v.id);
      if (v.featured_media && v.featured_media.id) showMedia(v.featured_media.id);
      fetch(base + '?variant=' + v.id + '&section_id=' + sid).then(function (r) { return r.text(); }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html');
        ['[data-price]', '[data-buy]', '[data-stock]'].forEach(function (s) {
          var n = d.querySelector(s), o = $(s, root); if (n && o) o.innerHTML = n.innerHTML;
        });
        if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
      });
    });
  }
  $$('[data-product-section]').forEach(initProduct);

  /* ---------- Related products ---------- */
  $$('[data-recommendations]').forEach(function (el) {
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (t) {
      var d = new DOMParser().parseFromString(t, 'text/html');
      var n = d.querySelector('[data-recommendations]');
      if (n && n.innerHTML.trim().length) { el.innerHTML = n.innerHTML; el.hidden = false; }
    });
  });

  /* =====================================================================
     MOBILE ENHANCEMENTS (all gated by isMobile(); desktop is unaffected)
     ===================================================================== */
  function isMobile() { return window.matchMedia('(max-width: 900px)').matches; }

  /* Header height -> CSS var (for sticky toolbars) */
  function setHeaderHeight() {
    var h = $('.header'); if (!h) return;
    var wrap = h.closest('.shopify-section') || h;
    var sticky = getComputedStyle(wrap).position === 'sticky' || getComputedStyle(h).position === 'sticky';
    document.documentElement.style.setProperty('--header-h', (sticky ? h.offsetHeight : 0) + 'px');
  }
  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);
  window.addEventListener('load', setHeaderHeight);

  /* Announcement bar: rotate one message at a time */
  (function () {
    var bar = $('.announcement'); if (!bar) return;
    var msgs = $$('.announcement__msg', bar); if (msgs.length < 2) return;
    bar.classList.add('js-rotate'); msgs[0].classList.add('is-active');
    var i = 0;
    setInterval(function () {
      if (!isMobile() || document.hidden) return;
      msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active');
    }, 3800);
  })();

  /* Footer accordion */
  $$('.footer__grid > div').forEach(function (col) {
    var h = col.querySelector('h4');
    if (h && col.querySelector('ul')) {
      col.classList.add('is-acc');
      h.setAttribute('role', 'button'); h.setAttribute('tabindex', '0'); h.setAttribute('aria-expanded', 'false');
    }
  });
  function toggleFooterCol(h) {
    var col = h.parentNode; col.classList.toggle('is-open');
    h.setAttribute('aria-expanded', col.classList.contains('is-open') ? 'true' : 'false');
  }
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches && e.target.matches('.footer__grid > div.is-acc > h4') && isMobile()) {
      e.preventDefault(); toggleFooterCol(e.target);
    }
  });

  /* Product gallery: keep dots/thumbs in sync while swiping */
  (function () {
    var gm = $('.gallery__main'); if (!gm) return;
    var raf;
    gm.addEventListener('scroll', function () {
      if (!isMobile()) return;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(gm.scrollLeft / (gm.clientWidth || 1));
        var s = gm.querySelectorAll('.gallery__slide')[i];
        if (s) showMedia(s.getAttribute('data-media-id'), true);
      });
    }, { passive: true });
  })();

  /* Sticky add-to-cart: show when the main button is out of view */
  (function () {
    var anchor = $('[data-buy-anchor]');
    if (!anchor || !T.stickyAtc) return;
    if (!('IntersectionObserver' in window)) { document.body.classList.add('sticky-visible'); return; }
    new IntersectionObserver(function (en) {
      document.body.classList.toggle('sticky-visible', !en[0].isIntersecting);
    }).observe(anchor);
  })();

  /* Collection: "Load more" */
  function loadMore(btn) {
    if (btn.getAttribute('aria-busy')) return;
    var label = btn.textContent;
    btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Loading…';
    fetch(btn.getAttribute('href')).then(function (r) { return r.text(); }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html');
      var grid = $('[data-product-grid]'), ngrid = d.querySelector('[data-product-grid]');
      if (grid && ngrid) { Array.prototype.slice.call(ngrid.children).forEach(function (c) { grid.appendChild(document.importNode(c, true)); }); }
      var old = $('[data-pagination]'), np = d.querySelector('[data-pagination]');
      if (old) { if (np) old.outerHTML = np.outerHTML; else old.remove(); }
    }).catch(function () { btn.removeAttribute('aria-busy'); btn.textContent = label; window.location.href = btn.getAttribute('href'); });
  }

  /* Live search suggestions (mobile) */
  (function () {
    if (!T.predictive) return;
    var bar = $('#search-bar'); if (!bar) return;
    var input = bar.querySelector('input[type=search]'), box = bar.querySelector('[data-suggest]');
    if (!input || !box) return;
    var timer, ctrl;
    function money(v) {
      var n = parseFloat(v) || 0, f = T.moneyFormat || '{{amount}}';
      function fx(num, dec, th, dp) { var p = num.toFixed(dec).split('.'); p[0] = p[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + th); return p[0] + (p[1] ? dp + p[1] : ''); }
      return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        switch (k) {
          case 'amount_no_decimals': return fx(n, 0, ',', '.');
          case 'amount_with_comma_separator': return fx(n, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return fx(n, 0, '.', ',');
          case 'amount_with_apostrophe_separator': return fx(n, 2, "'", '.');
          default: return fx(n, 2, ',', '.');
        }
      }).replace(/<[^>]*>/g, '');
    }
    function render(products, q) {
      box.textContent = '';
      if (!products.length) { var em = document.createElement('p'); em.className = 'suggest-empty'; em.textContent = 'No products found.'; box.appendChild(em); box.hidden = false; return; }
      products.forEach(function (p) {
        var a = document.createElement('a'); a.className = 'suggest-item'; a.href = p.url;
        var src = (p.featured_image && p.featured_image.url) || p.image;
        if (src) { var im = document.createElement('img'); im.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120'; im.alt = ''; im.loading = 'lazy'; a.appendChild(im); }
        var w = document.createElement('span');
        var t = document.createElement('span'); t.className = 'suggest-item__t'; t.textContent = p.title;
        var pr = document.createElement('span'); pr.className = 'suggest-item__p'; pr.textContent = money(p.price);
        w.appendChild(t); w.appendChild(pr); a.appendChild(w); box.appendChild(a);
      });
      var all = document.createElement('a'); all.className = 'suggest-all';
      all.href = T.routes.root.replace(/\/$/, '') + '/search?type=product&q=' + encodeURIComponent(q);
      all.textContent = 'See all results'; box.appendChild(all); box.hidden = false;
    }
    input.addEventListener('input', function () {
      if (!isMobile()) return;
      var q = input.value.trim(); clearTimeout(timer);
      if (q.length < 2) { box.hidden = true; box.textContent = ''; return; }
      timer = setTimeout(function () {
        if (ctrl && ctrl.abort) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        fetch(T.routes.root.replace(/\/$/, '') + '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6',
          { signal: ctrl ? ctrl.signal : undefined, headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (j) { render((j.resources && j.resources.results && j.resources.results.products) || [], q); })
          .catch(function () {});
      }, 250);
    });
  })();
})();
